import { z } from 'zod';

// 05-remediation.md 5.18 parte 3 -- schemas para las formas reales de request/response del
// dominio `comments`, verificados contra el DTO y los casos de uso del backend
// (`backend/src/comments/domain/CommentDTO.js`, `backend/src/comments/application/*`,
// `backend/src/shared/storage/toggleMediaAccess.js` para el toggle de visibilidad), no
// inventados desde cómo el frontend los consume hoy.
// `.parse()` en todos lados, `z.looseObject` en el DTO -- mismo criterio que el resto de
// schemas del repo (ver `client/schemas.js` para el razonamiento completo).

const nullish = (schema) => schema.nullish();
const id = z.union([z.string(), z.number()]);

// ── Comment (CommentDTO) ────────────────────────────────────────────────────────────────────
// `PgCommentRepository` siempre alias-ea `id AS comment_id` -- nunca hay un `id` crudo acá.
// `reactions` es un `jsonb_object_agg(user_id::text, reaction)` -- objeto `{userId: emoji}`,
// ausente en `update()`/`updateMetadata()` (solo lo agregan `create()`/`findByDocument()`/
// `toggleReaction()`).
export const CommentSchema = z.looseObject({
    comment_id: id,
    document_id: nullish(id),
    author_id: nullish(id),
    anchor_type: nullish(z.string()),
    comment_kind: nullish(z.string()),
    metadata: z.unknown().nullish(),
    status: nullish(z.string()),
    created_at: nullish(z.string()),
    updated_at: nullish(z.string()),
    content: nullish(z.string()),
    author_name: nullish(z.string()),
    author_avatar: nullish(z.string()),
    reactions: z.record(z.string(), z.string()).optional(),
});

export const ListCommentsResponseSchema = z.looseObject({
    success: z.boolean(),
    comments: z.array(CommentSchema).optional().default([]),
});

// `create`/`update`/`updateMetadata` devuelven el mismo sobre `{success, comment}`.
export const CommentResponseSchema = z.looseObject({
    success: z.boolean(),
    comment: CommentSchema,
});

// `ToggleReaction` agrega `reactions` suelto al nivel del sobre además de dentro de `comment`
// (`commentDTO.reactions`) -- `ComponentTaskHoy.jsx`/`Comments.jsx` leen el de arriba.
export const ToggleReactionResponseSchema = z.looseObject({
    success: z.boolean(),
    comment: CommentSchema,
    reactions: z.record(z.string(), z.string()).optional(),
});

export const DeleteCommentResponseSchema = z.looseObject({
    success: z.boolean(),
    comment_id: nullish(id),
});

// `toggleMediaAccess` (shared/storage) -- mismo sobre para docs/dataindex/tareas/recordings.
export const ToggleMediaVisibilityResponseSchema = z.looseObject({
    success: z.boolean(),
    access: nullish(z.string()),
    url: nullish(z.string()),
});
